
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registro do Service Worker (Otimizado para PWA)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Registra o SW em qualquer ambiente seguro (HTTPS) ou localhost
    const isLocalhost = Boolean(
      window.location.hostname === 'localhost' ||
      window.location.hostname === '[::1]' ||
      window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
    );

    // Registra se for HTTPS ou Localhost
    if (window.location.protocol === 'https:' || isLocalhost) {
      navigator.serviceWorker.register('/sw.js')
        .then(reg => {
          console.log('Equilibra PWA: Online (Scope: ' + reg.scope + ')');
        })
        .catch(err => {
          console.debug('SW falhou (comum em previews restritos):', err);
        });
    }
  });
}

// Previne menu de contexto no standalone
if (window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone) {
  document.addEventListener('contextmenu', event => event.preventDefault());
}
